export const visit = (vm, at) => {
at({ "pt-br": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Desculpe, n\xE3o foi poss\xEDvel confirmar seu endere\xE7o de e-mail." } } } });
};